import { useState, useEffect } from 'react';
import api from './api/axiosInstance.js';
import { useNavigate } from 'react-router-dom';
import { Container, Row, Col, Card, Form, Button} from 'react-bootstrap';


const PasswordReset = () => {
    const navigate = useNavigate();
    const [email, setEmail] = useState('');
    const [emailError, setEmailError] = useState('');
    const [message, setMessage] = useState('');
    const [sessionExpiredMessage, setSessionExpiredMessage] = useState(false);
    
    useEffect(() => {
        const flagFromSession = sessionStorage.getItem('sessionExpired') === 'true';
        const flagFromQuery = new URLSearchParams(window.location.search).get('sessionExpired') === 'true';

        if (flagFromSession || flagFromQuery) {
            setSessionExpiredMessage(true);
            sessionStorage.removeItem('sessionExpired');

            // ✅ Remove only the `sessionExpired` param, preserve others
            const params = new URLSearchParams(window.location.search);
            params.delete('sessionExpired');
            const cleanedUrl = `${window.location.pathname}${params.toString() ? '?' + params.toString() : ''}`;
            window.history.replaceState({}, document.title, cleanedUrl);
        }
    }, []);

    const handleEmailChange = (e) => {
        setEmail(e.target.value);
        setEmailError('');
    };

    const sendResetEmail = async () => {
        try {
            await api.post('/api/auth/send-reset-email', { email });
            setMessage('If an account exists for this email, reset instructions have been sent.');
        } catch (error) {
            console.error('Error sending reset email:', error);
            setMessage('Failed to send the reset instructions. Please try again later.');
        }
    };

    const handleFindAccount = async (e) => {
        e.preventDefault();
        setEmailError('');
        setMessage('');

        try {
            await sendResetEmail();
        } catch (err) {
            console.error('Reset request failed:', err);
            setEmailError('Something went wrong. Please try again later.');
        }
    };

    const handleCancel = () => {
        navigate('/');
    };

    return (
        <main className="main-content flex-grow-1 ms-0">
            <Container>
                <Row>
                    {/* Main Content */}
                    <Col xl={4} className="offset-xl-4 pt-5">
                        <Card>
                            <Card.Body>
                                <div>
                                    <h2>Reset Your Password</h2>    
                                    <p>Access your account by entering your details below.</p>  
                                </div>
                                <Form onSubmit={handleFindAccount}>
                                    <Form.Group controlId="email" className="mb-4">
                                        <Form.Label>Email Address</Form.Label>
                                        <Form.Control
                                            type="email"
                                            value={email}
                                            onChange={handleEmailChange}
                                            required
                                            placeholder="Enter your email address"
                                        />
                                        {emailError && <p style={{ color: 'red' }}>{emailError}</p>}
                                    </Form.Group>
                                    {message && <p style={{ color: 'green' }}>{message}</p>}
                                    <div className="d-flex justify-content-between">
                                        <Button variant="outline-secondary" onClick={handleCancel}>
                                            Cancel
                                        </Button>
                                        <Button variant="primary" type="submit">
                                            Find Account
                                        </Button>
                                    </div>
                                </Form>
                            </Card.Body>
                        </Card>
                        {sessionExpiredMessage && (
                            <Row className="buttons-row">
                                <Col xs={12}>
                                    <Container>
                                        <Row>
                                            <Col xs={12}>
                                                <div className="alert alert-warning" role="alert">
                                                    Your session has expired. Please log in again.
                                                </div>
                                            </Col>
                                        </Row>
                                    </Container>
                                </Col>
                            </Row>
                        )}
                    </Col>
                </Row>
                
            </Container>
        </main>
    );
};

export default PasswordReset;
